import Vue from "vue";
import {
  create,
  all
} from "mathjs";
import moment from "moment";
moment.locale('zh-cn')

const mathjs = create(all);
mathjs.config({
  number: "BigNumber",
  precision: 64,
});

Vue.prototype.$tools = {
  math: mathjs,
  moment: moment,
  //获取时间离现在多久
  dateDiff: (item = '') => {
    const nowTime = new Date().getTime();
    const minuteTime = 60 * 1000;
    const hourTime = 60 * minuteTime;
    const dayTime = 24 * hourTime;
    const monthTime = dayTime * 30;
    const yearTime = monthTime * 12;

    const historyTime = new Date(item.replace(/-/g, '/')).getTime();
    const diffTime = parseInt(nowTime) - parseInt(historyTime);

    let descTime;
    if (diffTime >= yearTime) {
      // 按年算
      descTime = parseInt(diffTime / yearTime) + '年前';
    } else if (diffTime < yearTime && diffTime >= monthTime) {
      //按月算
      descTime = parseInt(diffTime / monthTime) + '月前';
    } else if (diffTime < monthTime && diffTime >= dayTime) {
      //按天算
      descTime = parseInt(diffTime / dayTime) + '天前';
    } else if (diffTime < dayTime && diffTime >= hourTime) {
      //按小时算
      descTime = parseInt(diffTime / hourTime) + '小时前';
    } else if (diffTime < hourTime && diffTime >= minuteTime) {
      //按分钟算
      descTime = parseInt(diffTime / minuteTime) + '分钟前';
    } else {
      descTime = '刚刚';
    }
    return descTime;

  },
  evaluate: (exp) => {
    let num = mathjs.format(mathjs.evaluate(exp));
    return Number(num);
  },
  // 分割一个整数
  formatNum(num) {
    if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
      return num;
    }
    var a = RegExp.$1,
      b = RegExp.$2,
      c = RegExp.$3;
    var re = new RegExp().compile("(\\d)(\\d{3})(,|$)");
    while (re.test(b)) b = b.replace(re, "$1,$2$3");
    return a.replace(/0/g, 1) + "" + b.replace(/0/g, 3) + "" + c.replace(/0/g, 5);
  },
  //彩票期数逻辑
  whatIsNextlotteryStatu(item) {
    let status = ''
    if (item.current == undefined) {
      status = "next";
    } else {
      status = 'current'
    }
    return status;
  },
  //随机一个开奖号码
  randLottery(lotteryType) {
    switch (lotteryType) {
      case "SSC":
        return Vue.prototype.$tools.randomNum({
          min: 0,
          max: 9,
          len: 5
        });
      case "PCDD":
        return Vue.prototype.$tools.randomNum({
          min: 0,
          max: 9,
          len: 3
        });
      case "LHC":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49']).slice(0, 7)
      case "LSC":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60',]).slice(0, 7)
      case "K3":
        return Vue.prototype.$tools.randomSortNum({
          min: 1,
          max: 6,
          len: 3
        });
      case "PK10":
        return Vue.prototype.$tools.randomArray(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'])
      case "11X5":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']).slice(0, 5)
      case "PL3":
        return Vue.prototype.$tools.randomNum({
          min: 0,
          max: 9,
          len: 3
        });
      case "3D":
        return Vue.prototype.$tools.randomNum({
          min: 0,
          max: 9,
          len: 3
        });
      case "SSQ":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33']).slice(0, 6).sort((a, b) => Number(a) - Number(b))
          .concat(Vue.prototype.$tools.randomNum({
            min: 1,
            max: 16,
            len: 1,
            zero: true
          }))
      case "DLT":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35']).slice(0, 5).sort((a, b) => Number(a) - Number(b))
          .concat(Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']).slice(0, 2).sort((a, b) => Number(a) - Number(b)))
    }
  },
  //随机一个开奖号码 dafacp
  randLottery_dfcp(lotteryType, srcData) {
    switch (lotteryType) {
      case "SSC":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 9) + 1
          return `${num}`
        })
        return srcData
      case "PCDD":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 11) + 1
          return `${num}`
        })
        return srcData
      case "LHC":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 49) + 1
          return num < 10 ? `0${num}` : `${num}`
        })
        return srcData
      case "LSC":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 60) + 1
          return num < 10 ? `0${num}` : `${num}`
        })
        return srcData
      case "K3":
        return Vue.prototype.$tools.randomSortNum({
          min: 1,
          max: 6,
          len: 3
        });
      case "PK10":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10'])
      case "11X5":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 11) + 1
          return num < 10 ? `0${num}` : `${num}`
        })
        return srcData
      case "PL3":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 9) + 1
          return `${num}`
        })
        return srcData
      case "3D":
        srcData = srcData.map((e, i) => {
          let num = (parseInt(e) % 9) + 1
          return `${num}`
        })
        return srcData
      case "SSQ":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33']).slice(0, 6).sort((a, b) => Number(a) - Number(b))
          .concat(Vue.prototype.$tools.randomNum({
            min: 1,
            max: 16,
            len: 1,
            zero: true
          }))
      case "DLT":
        return Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35']).slice(0, 5).sort((a, b) => Number(a) - Number(b))
          .concat(Vue.prototype.$tools.randomArray(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']).slice(0, 2).sort((a, b) => Number(a) - Number(b)))
    }
  },

  //打乱数组
  randomArray(arr) {
    return [...arr].sort(function () {
      return (0.5 - Math.random());
    });
  },
  // 可重复，不排序
  randomNum({
    min,
    max,
    len,
    zero
  }) {
    let list = [];
    for (let i = 0; i < len; i++) {
      let numb = String(Vue.prototype.$tools.random(min, max));
      list.push(zero === true && numb.length == 1 ? `0${numb}` : numb);
    }
    return list;
  },
  // 可重复，从小到大排列
  randomSortNum({
    min,
    max,
    len,
    zero
  }) {
    let list = [];
    for (let i = 0; i < len; i++) {
      let numb = String(Vue.prototype.$tools.random(min, max));
      list.push(zero === true && numb.length == 1 ? `0${numb}` : numb);
    }
    return list.sort((a, b) => Number(a) - Number(b));
  },
  orderStatus: ["未开奖", "已中奖", "手工撤单", "系统撤单", "未中奖", "下单失败", "和局撤单", "系统撤销", "派彩回滚"],
  //判断是否标签 text 文本， tagName标签名
  hasTag(text, tagName) {
    return new RegExp(`<(\/?${tagName}.*?)>`).test(text);
  },
  //隐藏银行卡显示前四位后四位
  hidenBankNumber(bankNumber) {
    return `${bankNumber.slice(0, 4).replace(/\*/g, '')} **** **** ${bankNumber.slice(-4).replace(/\*/g, '')}`;
  },

  //阿拉伯数字转中文
  toChinesNum(num) {
    let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"]; //changeNum[0] = "零"
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
      let strArr = temp
        .toString()
        .split("")
        .reverse();
      let newNum = "";
      for (var i = 0; i < strArr.length; i++) {
        newNum = (i == 0 && strArr[i] == 0 ? "" : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) + newNum;
      }
      return newNum;
    };
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
  },
  color2rgb(col) {
    if (col[0] == "#") {
      col = col.slice(1);
    }

    var r = parseInt(col.substring(0, 2), 16);

    var g = parseInt(col.substring(2, 4), 16);

    var b = parseInt(col.substring(4, 6), 16);
    return `${r},${g},${b}`;
  },
  Color(col, amt) {
    amt = parseInt(amt * 0.01 * 255);
    var usePound = false;

    if (col[0] == "#") {
      col = col.slice(1);
      usePound = true;
    }

    var num = parseInt(col, 16);

    var r = parseInt(col.substring(0, 2), 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    var g = parseInt(col.substring(2, 4), 16) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    var b = parseInt(col.substring(4, 6), 16) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    var css = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

    return css;
  },
  addFavorite() {
    //网址收藏
    var url = window.location;
    var title = document.title;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("360se") > -1) {
      $nuxt.$alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
    } else if (ua.indexOf("msie 8") > -1) {
      window.external.AddToFavoritesBar(url, title); //IE8
    } else if (document.all) {
      //IE类浏览器
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        $nuxt.$alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
      }
    } else if (window.sidebar) {
      //firfox等浏览器；
      window.sidebar.addPanel(title, url, "");
    } else {
      $nuxt.$alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
    }
  },
  isQQBrowser() {
    return navigator.userAgent.indexOf("MQQBrowser") > -1 || navigator.userAgent.indexOf("QQTheme") > -1;
  },
  /**
   * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 idle，action 才会执行
   * @param idle   {number}    空闲时间，单位毫秒
   * @param action {function}  请求关联函数，实际应用需要调用的函数
   * @return {function}    返回客户调用函数
   */
  debounce: function (idle, action) {
    var last;
    return function () {
      var ctx = this,
        args = arguments;
      clearTimeout(last);
      last = setTimeout(function () {
        action.apply(ctx, args);
      }, idle);
    };
  },
  //节流
  throttle: function (t, fn) {
    let last;
    let timer;
    let interval = t || 500;
    return function () {
      let args = arguments;
      let now = +new Date();
      if (last && now - last < interval) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          last = now;
          fn.apply(this, args);
        }, interval);
      } else {
        last = now;
        fn.apply(this, args);
      }
    };
  },
  objectToKeyVal(obj = {
    name: "joe",
    age: 12
  }) {
    let str = "";
    for (let item in obj) {
      str += `${item}=${obj[item]}&`;
    }
    return str;
  },
  getRouteAfterPath(pathname) {
    //获取pathname后的路径
    let pathArr = window.location.href.split("/");
    let index = pathArr.indexOf(pathname);
    if (index != -1) {
      return pathArr[index + 1];
    }
    return undefined;
  },
  //获得两个数组中对方没有的元素
  getArrDifference(arr1, arr2) {
    return arr1.concat(arr2).filter(function (v, i, arr) {
      return arr.indexOf(v) === arr.lastIndexOf(v);
    });
  },
  //取两个数组中相同的元素
  getArrEqual(arr1, arr2) {
    let newArr = [];
    for (let i = 0; i < arr2.length; i++) {
      for (let j = 0; j < arr1.length; j++) {
        if (arr1[j] === arr2[i]) {
          newArr.push(arr1[j]);
        }
      }
    }
    return newArr;
  },
  //随机获取数组中n个元素, 保持顺序
  getRandomArrayItems(arr, n) {
    n = n > arr.length ? arr.length : n
    const oArr = [...arr].map((item, index) => {
      return {
        i: index,
        o: item
      }
    })
    const nArr = []
    for (let i = 0; i < n; i++) {
      const random = Math.floor(Math.random() * oArr.length)
      nArr.push(oArr[random])
      oArr.splice(random, 1)
    }
    return nArr.sort((item1, item2) => item1.i - item2.i).map(item => item.o)
  },
  uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },
  //随机
  random(lower, upper) {
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  },
  checkNumber(e, defaultText = "", max = 9999999) {
    let numb = `${e}`;

    if (e[0] == 0) {
      numb = numb.slice(1, numb.length);
    }

    numb = numb.replace(/[^\d]+/, "");

    if (numb >= max) {
      return max
    } else if (numb > 0 && numb < max) {
      return numb
    } else {
      return defaultText
    }
  },
  checkBetNumber(e) {
    var regPos = /^\d+(\d+)?$/;
    var regNeg = /^(-(([0-9]+[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数

    if (e.length == 0 || e == 0 || !(regPos.test(e) || regNeg.test(e))) {
      return;
    }
    if (e[0] == 0) {
      return e.slice(1, e.length);
    }
    if (regPos.test(e) || regNeg.test(e)) {
      return e;
    } else {
      return e.slice(0, e.length - 1);
    }
  },
  formatDecimal(num, decimal) {
    num = num.toString()
    let index = num.indexOf('.')
    if (index !== -1) {
      num = num.substring(0, decimal + index + 1)
    } else {
      num = num.substring(0)
    }
    return parseFloat(num).toFixed(decimal)
  },
  //除法
  accDiv(num1, num2) {
    if (num1 === undefined) return;

    var t1, t2, r1, r2;

    try {
      t1 = num1.toString().split(".")[1].length;
    } catch (e) {
      t1 = 0;
    }

    try {
      t2 = num2.toString().split(".")[1].length;
    } catch (e) {
      t2 = 0;
    }

    r1 = Number(num1.toString().replace(".", ""));

    r2 = Number(num2.toString().replace(".", ""));

    return (r1 / r2) * Math.pow(10, t2 - t1);
  },
  //乘法
  accMul(arg1, arg2) {
    if (arg1 === undefined) return;

    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();

    try {
      m += s1.split(".")[1].length;
    } catch (e) { }

    try {
      m += s2.split(".")[1].length;
    } catch (e) { }

    return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
  },
  //加法
  accAdd(arg1, arg2) {
    var r1, r2, m;

    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }

    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }

    m = Math.pow(10, Math.max(r1, r2));

    return (arg1 * m + arg2 * m) / m;
  },
  //减法
  Subtr(arg1, arg2) {
    var r1, r2, m, n;

    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }

    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }

    m = Math.pow(10, Math.max(r1, r2));

    n = r1 >= r2 ? r1 : r2;

    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  },
  formateIOS(time) { //把"YYYY-MM-DD HH:mm"转成"YYYY/MM/DD HH:mm" 以兼容ios
    if (!time) {
      return 0
    }
    var myDate = new Date((time.replace(/-/g, "/")));
    return myDate;
  },
  //现实数组的全排列
  arrCombion(nu, groupl, result) {
    var result = result ? result : [];
    var nuc = nu.slice(0);
    var item = nuc.shift();
    item = item.constructor === Array ? item : [item];

    (function func(item, nuc) {
      var itemc;
      var nucc = nuc.slice(0);
      var margin = groupl - item.length;
      if (margin == 0) {
        result.push(item);
        return;
      }
      if (margin == 1) {
        nuc.forEach((i, j) => {
          itemc = item.slice(0);
          itemc.push(nuc[j]);
          result.push(itemc);
        });
      }
      if (margin > 1) {
        itemc = item.slice(0);
        itemc.push(nucc.shift());
        func(itemc, nucc);

        if (item.length + nucc.length >= groupl) {
          func(item, nucc);
        }
      }
    })(item, nuc);
    if (nuc.length >= groupl) {
      return this.arrCombion(nuc, groupl, result);
    } else return result;
  },

  transRecordStatus(status) {
    switch (Number(status)) {
      case 1:
        return "需要check";
        break;
      case 2:
        return "失败";
        break;
      case 3:
        return "成功";
        break;
    }
  },
  rechargeStatus(status) {
    switch (Number(status)) {
      case 1:
        return "未处理";
        break;
      case 2:
        return "处理中";
        break;
      case 3:
        return "充值成功";
        break;
      case 4:
        return "充值失败";
        break;
      case 5:
        return "已过期";
        break;
    }
  },
  rechargeTypes(status) {
    switch (Number(status)) {
      case 99:
        return "免提直充";
        break;
    }
  },
  withdrawalStatus(status) {
    switch (Number(status)) {
      case 0:
        return "未处理";
        break;
      case 1:
        return "处理中";
        break;
      case 2:
        return "处理中";
        break;
      case 3:
        return "提款成功";
        break;
      case 4:
        return "提款失败";
        break;
    }
  },
  /**
   * 提现类型
   * @param {*} status 
   * @returns 
   */
  withdrawTypes(status) {
    switch (Number(status)) {
      case 1:
        return "三方代付提款";
        break;
      case 2:
        return "银行卡转账提现";
        break;
      case 10:
        return "USDT提现";
        break;
      case 20:
        return "支付宝提现";
        break;
      case 30:
        return "微信提现";
        break;
      case 40:
        return 'GOPay钱包提现';
        break;
      case 50:
        return 'OKPay钱包提现';
        break;
      case 60:
        return 'ToPay钱包提现';
        break;
      case 70:
        return 'CGPay钱包提现';
        break;
      //新增钱包添加
      case 80:
        return '988Pay钱包提现';
        break;
      case 90:
        return 'FPay钱包提现';
        break;
      case 100:
        return 'K豆钱包提现';
        break;
      case 110:
        return 'AGPay钱包提现';
        break;
      case 120:
        return '万币钱包提现';
        break;
      case 130:
        return 'ABPay钱包提现';
        break;
      case 140:
        return 'GDPay钱包提现';
        break;
      case 150:
        return 'AGPay(内)钱包提现';
        break;
      case 160:
        return 'EBPay钱包提现';
        break;
      case 170:
        return 'TGPay钱包提现';
        break;
      case 180:
        return 'MPay钱包提现';
        break;
      case 190:
        return '易币付钱包提现';
        break;
      case 200:
        return 'VIPPay钱包提现';
        break;
      case 210:
        return 'C币钱包提现';
        break;
      case 220:
        return 'BBPay钱包提现';
        break;
      case 230:
        return 'OPay钱包提现';
        break;
      case 240:
        return 'YZPay钱包提现';
        break;
      case 250:
        return 'AIPay钱包提现';
        break;
      case 260:
        return 'K宝钱包提现';
        break;
      case 270:
        return 'UPay钱包提现';
        break;
      case 280:
        return '波币钱包提现';
        break;
      case 280:
        return '波币钱包提现';
        break;
      case 300:
        return '568钱包提现';
        break;
      case 310:
        return 'EB2Pay钱包提现';
        break;
      case 320:
        return '钱能钱包提现';
        break;
      case 330:
        return 'JJPay钱包提现';
        break;
      case 340:
        return 'OBPay钱包提现';
        break;
      case 350:
        return '808Pay钱包提现';
        break;
      case 360:
        return 'JDPay钱包提现';
        break;
      case 370:
        return 'CFBPay钱包提现';
      case 380:
        return '购宝钱包提现';
        break;
      case 390:
        return 'OEPay钱包提现';
        break;
      case 400:
        return 'GdPay(内)钱包提现';
        break;
      case 410:
        return 'VipPay(内)钱包提现';
        break;
      case 420:
        return 'KKPay钱包提现';
        break;
      case 430:
        return '77Pay钱包提现';
        break;
      case 440:
        return 'IPay钱包提现';
        break;
      case 450:
        return '欧宝(内)钱包提现';
        break;
      case 460:
        return '秒付钱包提现';
        break;
      case 470:
        return '988Pay2钱包提现';
        break;
      case 480:
        return 'QTPay钱包提现';
        break;
      case 490:
        return '币趣钱包提现';
        break;
      case 500:
        return '365钱包提现';
        break;
      case 510:
        return 'M币钱包提现';
        break;
      case 520:
        return '99u钱包提现';
        break;
      case 540:
        return '98pay钱包提现';
      case 550:
        return '99pay钱包提现';
      case 560:
        return '24CoinPay钱包';
        break;
      case 570:
        return 'AaPay钱包';
        break;
      case 580:
        return '波币(内)钱包';
        break;
      case 590:
        return '支付宝钱包';
        break;
      case 600:
        return '588Pay钱包';
        break;
      case 610:
          return '纷享钱包';
          break;
      case 1000:
        return '挂单提现';
        break;
      case 1010:
        return '挂单提现plus';
        break;
    }
  },
  rnPostMessage(type, params) {
    //通过iframe嵌套通知方式
    if (window.parent) {
      window.parent.postMessage(JSON.stringify({ //接收端收到的为序列化的json字符串
        type,
        params
      }), '*')
    }
    //通过 reactnative
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ //接收端收到的为序列化的json字符串
        type,
        params
      }))
    }
  },
  /**
   * 对象深合并
   * @param {} obj1 
   * @param {*} obj2 
   * @returns 
   */
  deepMerge(obj1, obj2) {
    obj1 = JSON.parse(JSON.stringify(obj1))
    obj2 = JSON.parse(JSON.stringify(obj2))
    let key;
    for (key in obj2) {
      // 如果target(也就是obj1[key])存在，且是对象的话再去调用deepMerge，否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
      obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" ? this.deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key]);
    }
    return obj1;
    //  obj1  的结果如下：

    //  {"a":{"b":{"0": "A", "1": "B", "2": "C", "c": "111"}}}
  }


};

Number.prototype.toFixed2 = function () {
  //只截取两位小数点 不四舍五入
  var numb = this;
  var tNumb = numb;

  if (numb < 0) tNumb = numb * -1;

  return numb < 0 ? (Math.floor(tNumb * 100) / 100) * -1 : Vue.prototype.$tools.accDiv(Math.floor(Vue.prototype.$tools.accMul(tNumb, 100)), 100);
};

Number.prototype.fixed2 = function (len = 2) {
  let rlen = len == 0 ? 0 : len + 1;
  let tstr = this + "";
  let _pointIndex = tstr.indexOf(".");
  if (_pointIndex != -1) {
    tstr = this + "00000";
  } else {
    tstr = this + ".00000";
  }
  return tstr.substring(0, tstr.indexOf(".") + rlen);
};
//toFixed修复版
Number.prototype.toFixedFix = function (len = 2) {
  var num = this;
  var times = Math.pow(10, 2);
  var des = num * times + 0.5;
  des = parseInt(des, 10) / times;
  return des.toFixed(len)
}

if (!("classList" in document.documentElement)) {
  Object.defineProperty(HTMLElement.prototype, "classList", {
    get: function () {
      var self = this;

      function update(fn) {
        return function (value) {
          var classes = self.className.split(/\s+/g),
            index = classes.indexOf(value);

          fn(classes, index, value);
          self.className = classes.join(" ");
        };
      }

      return {
        add: update(function (classes, index, value) {
          if (!~index) classes.push(value);
        }),

        remove: update(function (classes, index) {
          if (~index) classes.splice(index, 1);
        }),

        toggle: update(function (classes, index, value) {
          if (~index) classes.splice(index, 1);
          else classes.push(value);
        }),

        contains: function (value) {
          return !!~self.className.split(/\s+/g).indexOf(value);
        },

        item: function (i) {
          return self.className.split(/\s+/g)[i] || null;
        },
      };
    },
  });
}

export const tools = Vue.prototype.$tools